import React from 'react';
import './Header.css'

export const Header = () => {
  return (
    <div className='header'>
      <h1>The Ricky And Morty</h1>
    </div>
  )
}